export const ModalScreen = () => {
  return <></>;
};
